import { DatabaseLayoutType } from '@databases/types/database/view';
import * as Parsimmon from 'parsimmon';

import { TokenType } from '../types';

export const LayoutLang = Parsimmon.createLanguage({
  /**
   * <Statement> -> table|gallery|<Board>
   *
   * "table" and "gallery" are terminals
   * @param r - language
   */
  Statement: function (r) {
    return Parsimmon.alt(
      Parsimmon.string('table').map(() => DatabaseLayoutType.TABLE),
      Parsimmon.string('gallery').map(() => DatabaseLayoutType.GALLERY),
      Parsimmon.string('calendar').map(() => DatabaseLayoutType.CALENDAR),
      r.Board
    ).map((result) => {
      if (
        result === DatabaseLayoutType.TABLE ||
        result === DatabaseLayoutType.GALLERY ||
        result === DatabaseLayoutType.CALENDAR
      ) {
        return {
          tokenType: TokenType.LAYOUT,
          type: result
        };
      } else {
        return {
          tokenType: TokenType.LAYOUT,
          ...result
        };
      }
    });
  },

  Board: function (r) {
    return Parsimmon.seq(Parsimmon.string('board:'), r.FieldName).map(
      ([_, fieldName]) => ({
        type: DatabaseLayoutType.BOARD,
        groupField: fieldName
      })
    );
  },

  FieldName: function () {
    return Parsimmon.all.map((s) => s.trim());
  },

  _: function () {
    return Parsimmon.whitespace;
  }
});
